import React from "react";

const MetaTags = ({ meta, extra }) => {
    if (!meta) return null;
    const { title, description, image, noIndex, pageType } = meta || {};
    let { handle } = meta || {};

    const SITE_URL = "https://sealskincovers.com";

    if (handle?.startsWith("/")) handle = handle.slice(1);
    if (handle?.endsWith("/")) handle = handle.slice(0, -1);

    const isMainHost = typeof window !== "undefined" && window.location.hostname === "sealskincovers.com";

    return (
        <>
            <html href={SITE_URL} lang={process.env.GATSBY_COUNTRY} />
            <title>{`${title}`}</title>
            <link rel="shortcut icon" href="//sealskincovers.com/cdn/shop/files/favicon_32x32.png?v=1614289589" type="image/png" />
            {extra && extra.map((item) => item.content)}

            <meta property="og:site_name" content="Sealskin Covers" />
            <meta property="og:url" content={`${SITE_URL}/${handle}`} />
            <meta property="og:title" content={title} />
            <meta property="og:type" content={pageType || "website"} />
            <meta name="description" property="og:description" content={description} />
            <meta property="og:image" content={image} />
            {(noIndex || (process.env.GATSBY_NO_INDEX && process.env.GATSBY_NO_INDEX === "true" && !isMainHost)) && <meta name="robots" content="noindex" />}

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta property="twitter:domain" content={SITE_URL} />
            <meta property="twitter:url" content={SITE_URL} />

            <script id="mcjs">
                {`!function(c,h,i,m,p){m = c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/7f7b5a356d50c126c453b8f0a/8d78c30b7258795c35ec73030.js");`}
            </script>
        </>
    );
};

export default MetaTags;
